/*NAVIGATION BAR DOESNT HAVE STATES*/

import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Txt from '../../inputs/textInput.js';

export default function NavItem(props) {
  const [text, setText] = useState(props.text);
  const [url, setUrl] = useState(props.url);
  const [isIndex, setIsIndex] = useState(props.isIndex);
  const [searchBar, setSearchBar] = useState(props.searchBar);
  const [multiOption, setMultiOption] = useState(props.multiOption);
  const [cssClasses, setCssClasses] = useState(props.cssClasses || '');
  const [amILeftAligned, setAmILeftAligned] = useState(props.amILeftAligned);
  const [hiddenBecauseOfLeftPosition, setHiddenBecauseOfLeftPosition] = useState(props.hiddenBecauseOfLeftPosition);
  const [currentPageTitle, setCurrentPageTitle] = useState(props.currentPageTitle);

  useEffect(() => {
    setAmILeftAligned(props.amILeftAligned);
    setHiddenBecauseOfLeftPosition(props.hiddenBecauseOfLeftPosition);
    setCurrentPageTitle(props.currentPageTitle);
  }, [props.amILeftAligned, props.hiddenBecauseOfLeftPosition, props.currentPageTitle]);

  //HOT RELOAD ONLY WORKS INSIDE THE RENDER FUNCTION
  // TODO: Check why using st? Change st to props if possible
  if (multiOption != undefined) {
    return (
      <Txt
        dropdown
        menudropdown
        currentPageTitle={currentPageTitle}
        cssClasses={cssClasses}
        multiOption={multiOption}
        text={text}
        amILeftAligned={amILeftAligned}
        {...props}
      />
    );
  } else if (url && url.indexOf('displaypage') > -1) {
    return (
      <a className="item" href={`/${url}`}>
        {text}
      </a>
    );
  } else if (searchBar) {
    var currentclasses = ' right menu ' + cssClasses;
    return (
      <div
        className={
          amILeftAligned
            ? 'menu-bar-search item color-input-highlight pdls pdrxs ' + currentclasses
            : 'color-input-highlight ' + currentclasses
        }
      />
    );
  } else if (props.VCCURL) {
    return (
      <a className="item" href={props.VCCURL} target="vcc">
        {text}
      </a>
    );
  } else if (isIndex) {
    return (
      <NavLink exact className="item text" to={`/${url}`}>
        {text}
      </NavLink>
    );
  } else {
    return (
      <Link className="item text" to={`/${url}`}>
        {text}
      </Link>
    );
  }
}

NavItem.propTypes = {
  //THIS DETERMINES WHICH ARGUMENTS ARE MANDATORY AND WHICH OPTIONAL FOR THIS MODULE
  searchBar: PropTypes.bool,
  isIndex: PropTypes.bool,
  multiOption: PropTypes.string,
  cssClasses: PropTypes.string,
  amILeftAligned: PropTypes.bool,
};
